export function title(state, title) {
  state.title = title
}
export function navColor(state, navColor) {
  state.navColor = navColor
}
export function navTextColor(state, navTextColor) {
  state.navTextColor = navTextColor
}
export function showNav(state, showNav) {
  state.showNav = showNav
}

export function backTo(state, data) {
  state.backTo = data
}

export function dialogDealer(state, data) {
  state.dialogDealer = data
}

export function typeVehicle(state, data) {
  state.typeVehicle = data
}

export function dialogMainMenu(state, data) {
  state.dialogMainMenu = data
}

export function drawerMenu(state, data) {
  state.drawerMenu = data
}
